import {
    IPortalShellDevProperties,
    IPortalShellGlobalProperties,
} from '../../models/globalScript';
import store from '../../store/store';
import { AccountAndTenantsInstanceResolver } from '../accountAndTenants/accountAndTenantsInstanceResolver';
import Logger from '../logger/logger';

export class GlobalPropsInstanceResolver {
    private static _globalPropsInstance: IPortalShellGlobalProperties = {
        devProperties: { mode: 'auto' },
        featureFlagOverrides: {},
    };

    public static Instantiate(globalPropsInstance: IPortalShellGlobalProperties) {
        Logger.debug('GlobalPropsInstanceResolver', 'Instantiate', { object: globalPropsInstance });

        window.PortalShell.GlobalProperties.devProperties = globalPropsInstance.devProperties;
        window.PortalShell.GlobalProperties.featureFlagOverrides = globalPropsInstance.featureFlagOverrides;

        this._globalPropsInstance = globalPropsInstance;

        if (globalPropsInstance.featureFlagOverrides) {
            window.PortalShell.FeatureFlags?.setOverrideFlags(globalPropsInstance.featureFlagOverrides);
        }

        if (globalPropsInstance.devProperties?.debugMode != null) {
            Logger.setDebugMode(!!globalPropsInstance.devProperties?.debugMode);
        }

        if (globalPropsInstance.devProperties?.organizationStandardUrl) {
            AccountAndTenantsInstanceResolver.Instance?.fetchAccountAndTenants();
        }

        if (globalPropsInstance.devProperties?.tenant && !globalPropsInstance.devProperties?.organizationStandardUrl) {
            AccountAndTenantsInstanceResolver.Instance?.updateCurrentTenant(globalPropsInstance.devProperties.tenant);
        }

        store.set('mode', globalPropsInstance.devProperties?.mode ?? 'auto');

        return this._globalPropsInstance;
    }

    public static get Instance() {
        return this._globalPropsInstance;
    }

    public static updateDevProperties(devProperties: IPortalShellDevProperties) {
        Logger.debug('GlobalPropsInstanceResolver', 'updateDevProperties', { object: devProperties });

        this._globalPropsInstance.devProperties = {
            ...this._globalPropsInstance.devProperties,
            ...devProperties,
        };

        window.PortalShell.GlobalProperties.devProperties = this._globalPropsInstance.devProperties;

        if (devProperties.organizationStandardUrl) {
            AccountAndTenantsInstanceResolver.Instance?.fetchAccountAndTenants();
        }

        if (devProperties.tenant && !devProperties.organizationStandardUrl) {
            AccountAndTenantsInstanceResolver.Instance?.updateCurrentTenant(devProperties.tenant);
        }

        if (devProperties.mode) {
            store.set('mode', devProperties.mode);
        }

        if (devProperties.debugMode != null) {
            Logger.setDebugMode(!!devProperties.debugMode);
        }
    }
}
